import React, { FC } from 'react';
import { LegacyAppointment } from '../../../../../interfaces/api/Collaborative';
import { createUseStyles } from '../../../../../theming';
import { CardContent, Grid, TextField, Typography } from '@material-ui/core';
import Card from '../../../../../components/Card';
import moment from 'moment';
import AppointmentTypeSelect from '../../../../../components/ApiField/AppointmentTypeSelect';
import DateTimePicker from '../../../../../components/DateTimePicker';
import { CriticitySelect } from '../../../../../components/ApiField';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import LegacyEmployeeView from '../../../../../components/ApiField/LegacyEmployeeView';
import EmployeeConcernedCard from './components/EmployeeConcernedCard';

const useStyles = createUseStyles({
  root: {
    padding: '3vh 10vw',
  },
});

interface Props {
  appointment: LegacyAppointment;
}

const AppointmentView: FC<Props> = ({ appointment }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant='overline' style={{ marginTop: 20 }} color='primary'>
                      Fiche rendez-vous
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      variant='outlined'
                      label='Titre'
                      defaultValue={appointment.title}
                      InputProps={{ readOnly: true }}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <AppointmentTypeSelect onChange={() => {}} value={appointment.appointmentTypeId} fullWidth />
                  </Grid>

                  <Grid item xs={12}>
                    <DateTimePicker
                      onChange={(date) => {}}
                      label='Date du rendez-vous'
                      format='DD/MM/YYYY HH:mm'
                      inputVariant='outlined'
                      fullWidth
                      disabled={appointment.closed}
                      value={appointment.dateMeeting}
                      ampm={false}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <CriticitySelect onChange={(date) => {}} fullWidth value={appointment.criticity} />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label='Lieu'
                      placeholder='Lieu du rdv'
                      variant='outlined'
                      fullWidth
                      value={appointment.place}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label='Durée prévue (en min)'
                      type='number'
                      variant='outlined'
                      InputProps={{ inputProps: { min: 0 } }}
                      value={appointment.duration}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label='Créé le'
                      type='number'
                      variant='outlined'
                      InputProps={{ inputProps: { min: 0 } }}
                      value={moment(appointment.createdAt).format('DD/MM/YYYY HH:mm')}
                      fullWidth
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <LegacyEmployeeView label='Créateur' disabled employeeId={appointment.creatorId} />
                  </Grid>

                  {/*<div className='form-group'>*/}
                  {/*  <div className='alignHorizontal'>*/}
                  {/*    <label>Personnes concernées</label>*/}
                  {/*    <button*/}
                  {/*      onClick={() => this.openModal('employee-add')}*/}
                  {/*      type='button'*/}
                  {/*      className='btn btn-sm btn-outline-success'*/}
                  {/*    >*/}
                  {/*      <span className='icon icon-plus'></span>*/}
                  {/*    </button>*/}
                  {/*  </div>*/}
                  {/*  {employeesConcerned ? (*/}
                  {/*    employeesConcerned.map((data) => (*/}
                  {/*      <li className='list-group-item entity-row' key={data.user.id}>*/}
                  {/*        <Link to={linkToUser + data.user.id}>*/}
                  {/*          <span>{'@' + data.user.username}</span>*/}
                  {/*        </Link>*/}
                  {/*        <button*/}
                  {/*          onClick={() => this.openModal('employee-remove', data.id)}*/}
                  {/*          type='button'*/}
                  {/*          className='btn btn-sm btn-outline-success'*/}
                  {/*        >*/}
                  {/*          <span className='icon icon-cross'></span>*/}
                  {/*        </button>*/}
                  {/*      </li>*/}
                  {/*    ))*/}
                  {/*  ) : (*/}
                  {/*    <span>Chargement...</span>*/}
                  {/*  )}*/}
                  {/*  {noEmployees}*/}
                  {/*</div>*/}
                  {/*<TextAreaUpdate*/}
                  {/*  inputType={'text'}*/}
                  {/*  inputLabel={'Commentaire'}*/}
                  {/*  inputValue={this.state.text}*/}
                  {/*  submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'text')}*/}
                  {/*  toggleBlackOut={() => this.props.toggleBlackOut()}*/}
                  {/*/>*/}
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <EmployeeConcernedCard appointmentId={appointment.id} employeeIds={appointment.employeesIds} />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default AppointmentView;
